export default __webpack_public_path__ + "static/media/downActive.20ba002c.svg";